import { render, staticRenderFns } from "./RecordNotFound.vue?vue&type=template&id=62517d2e&"
import script from "./RecordNotFound.vue?vue&type=script&lang=js&"
export * from "./RecordNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports